module.exports = __webpack_public_path__ + "static/img/brand-6.0a7a37a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-6.svg
// module id = +EB9
// module chunks = 0